import type { PersonProfile } from '@openeducation/oe-rn-shared-types';
import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';

import { TeacherProfile } from '../../molecules/teacher-profile/teacher-profile';
import { TeacherFeedbackCard } from '../../organisms/teacher-feedback-card/teacher-feedback-card';
import { PortalLayout } from '../../templates/portal-layout/portal-layout';

export interface DashboardPageProps {
  teacherProfile: PersonProfile;
}

export const DashboardPage = ({ teacherProfile }: DashboardPageProps) => {
  return (
    <PortalLayout>
      <Container>
        <InformationContainer>
          <TeacherProfile
            accountName={teacherProfile.accountName}
            displayName={teacherProfile.displayName}
            facultyId={teacherProfile.w2wId}
            fullName={`${teacherProfile.firstName} ${teacherProfile.lastName}`}
            role={teacherProfile.roleDto.roleType}
            personId={teacherProfile.id}
          />
        </InformationContainer>

        <TeacherFeedbackCard />
      </Container>
    </PortalLayout>
  );
};

const Container = styled.View`
  min-height: 100vh;
  gap: 32px;
`;

const InformationContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  gap: 32px;
`;
